// SC-741 Salesforce Metadata Browser — frontend DTO mirrors.
// These match the server DTOs in ISalesforceService.cs (camelCase over the wire).

export interface SalesforcePicklistValue {
  value: string;
  label: string;
}

export interface SalesforceField {
  apiName: string;
  label: string;
  type: string; // raw Salesforce type (reference/currency/picklist/...)
  filterable: boolean; // usable in WHERE
  sortable: boolean; // usable in ORDER BY
  writable: boolean; // updateable
  calculated: boolean; // formula / calculated field
  relationshipName: string | null; // reference field's relationship name (parent dot-paths)
  referenceTo: string[] | null; // reference targets
  picklistValues: SalesforcePicklistValue[] | null;
}

export interface SalesforceRelationship {
  name: string | null; // relationship name (dot-path prefix / subquery alias)
  targetObject: string; // parent target / child object
  viaField: string; // the reference / foreign-key field
  isParent: boolean;
}

export interface SalesforceObjectMetadata {
  apiName: string;
  label: string;
  isCustom: boolean;
  fields: SalesforceField[];
  parentReferences: SalesforceRelationship[];
  childRelationships: SalesforceRelationship[];
}

// Mapped shape of the /salesforce/get-sobjects list items.
export interface SObjectListItem {
  entity: string; // API name
  name: string; // label
  isCustom: boolean;
}

// A child-relationship subquery selection: the child object and the child fields ticked for its
// (SELECT ... FROM RelationshipName) clause. Keyed by relationship name in the browser state.
export interface SubquerySelection {
  targetObject: string;
  fields: string[];
}

// A navigation crumb. Index 0 is the base object (relationshipName null). A parent hop
// (isChild falsy) contributes a dot-path prefix; a child hop (isChild true) is exploration only —
// SOQL can't dot-path through a child, so field selection is disabled once a child hop is present.
export interface PathCrumb {
  relationshipName: string | null;
  object: string;
  label: string;
  isChild?: boolean;
}

export const MAX_PARENT_DEPTH = 5;
export const METADATA_BROWSER_TID = 'salesforce.metadata-browser';
